// JS file for the About Us page

// Import Splide

import Splide from "@splidejs/splide";

// About hero section slider mount

var aboutHeroSlider = new Splide(".about-hero-slider", {
	type: "loop",
	arrows: false,
	pagination: false,
	padding: "10%",
	pauseOnFocus: true,
	pauseOnHover: true,
	autoWidth: true,
	gap: "3%",
	autoplay: true,
	interval: 5000,
	focus: "center",
	perMove: 1,
	breakpoints: {
		640: {
			padding: "3rem",
			gap: "20px",
			perPage: 1,
		},
	},
});

aboutHeroSlider.mount();

// About testimonial section slider mount

// var aboutTestimonialSlider = new Splide(".about-testimonial-slider", {
//   type: "loop",
//   arrows: false,
//   pagination: false,
//   padding: "3rem",
//   perPage: 1,
//   pauseOnFocus: true,
//   pauseOnHover: true,
//   gap: "40px",
//   fixedWidth: "50rem",
//   autoplay: true,
//   interval: 5000,
//   focus: "center",
//   breakpoints: {
//     1100: {
//       padding: "1rem",
//       fixedWidth: "40rem",
//     },
//     900: {
//       fixedWidth: "30rem",
//     },
//     600: {
//       fixedWidth: "20rem",
//       gap: "10px",
//     },
//     400: {
//       fixedWidth: "18rem",
//     },
//     300: {
//       fixedWidth: "16rem",
//     },
//   },
// });

// aboutTestimonialSlider.mount();

// Meet the team section slider mount

var meetOurTeamSlider = new Splide(".meet-our-team-slider", {
	type: "loop",
	arrows: false,
	pagination: false,
	padding: "3rem",
	perPage: 1,
	pauseOnFocus: true,
	pauseOnHover: true,
	gap: "40px",
	fixedWidth: "20rem",
	autoplay: true,
	interval: 5000,
	focus: "center",
	breakpoints: {
		600: {
			fixedWidth: "16rem",
		},
	},
});

meetOurTeamSlider.mount();

// Our Story section button toggle logic

document.addEventListener("DOMContentLoaded", () => {
	// Find all the parent elements that contain each pair of button and body
	const stories = document.querySelectorAll(".our-story-content");

	// Loop through each .our-story element
	stories.forEach((story) => {
		const button = story.querySelector(".our-story-button"); // Get the button that toggles show/hide
		const body = story.querySelector(".our-story-body"); // Get the story body where text is
		const buttonText = button.querySelector("span"); // Get the span that contains the text
		const buttonImage = button.querySelector("img"); // Get the img within the button

		button.addEventListener("click", () => {
			// Toggle the hidden class on the body
			body.classList.toggle("hidden");

			// Update the button text and class based on the body's visibility
			if (body.classList.contains("hidden")) {
				buttonText.textContent = "Show";
				buttonImage.src = "./images/arrow-down.svg";
			} else {
				buttonText.textContent = "Hide";
				buttonImage.src = "./images/arrow-up.svg";
			}
		});
	});
});
